import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// 🔐 Replace with your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCTkJzK3dhTxJjbDmiVMXYE0ACpO3xRPKg",
  authDomain: "ec-nomination-portal.firebaseapp.com",
  databaseURL: "https://ec-nomination-portal-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ec-nomination-portal",
  storageBucket: "ec-nomination-portal.appspot.com",
  messagingSenderId: "38543374393",
  appId: "1:38543374393:web:9787c24899af86a8a175e8",
  measurementId: "G-80CCY760J5"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
